import {Outlet} from "react-router-dom";
import {StepperUtil} from "base/stepper/utilities";
import {PERMIT_EXTENSION_STATUS, getRequiredFields} from "permitextension/data";

const usePermitExtensionSteps = (extension, isStepEditable = true) => {
    const getUncompleteFields = StepperUtil.getUncompleteFields;
    const isStepUntouched = StepperUtil.isStepUntouched;

    let steps = [];

    const contextForOutlet = {
        extension,
        isStepEditable,
    };

    if (extension) {
        const requiredFields = getRequiredFields(extension);

        const extensionSteps = [
            {
                order: 0,
                label: "Guias e datas",
                sublabel: "MFCE-M",
                path: "pendente_guias_e_datas",
                content: <Outlet context={contextForOutlet} />,
                status: PERMIT_EXTENSION_STATUS.pendente_guias_e_datas,
                uncompleteFields: getUncompleteFields(
                    requiredFields.pendente_guias_e_datas
                ),
                isStepUntouched: isStepUntouched(requiredFields.pendente_guias_e_datas),
            },
            {
                order: 1,
                label: "Parecer técnico",
                sublabel: "MFCE-M",
                path: "report_m",
                content: <Outlet context={contextForOutlet} />,
                status: PERMIT_EXTENSION_STATUS.report_m,
                uncompleteFields: getUncompleteFields(requiredFields.report_m),
                isStepUntouched: isStepUntouched(requiredFields.report_m),
            },
            {
                order: 2,
                label: "Valor de pagamento",
                sublabel: "MFCE-E",
                path: "payment_e",
                content: <Outlet context={contextForOutlet} />,
                status: PERMIT_EXTENSION_STATUS.payment_e,
                uncompleteFields: getUncompleteFields(requiredFields.payment_e),
                isStepUntouched: isStepUntouched(requiredFields.payment_e),
                forceBackButton: true,
            },
            {
                order: 3,
                label: "Factura",
                sublabel: "Secretaria",
                path: "invoice_s",
                content: <Outlet context={contextForOutlet} />,
                status: PERMIT_EXTENSION_STATUS.invoice_s,
                uncompleteFields: getUncompleteFields(requiredFields.invoice_s),
                isStepUntouched: isStepUntouched(requiredFields.invoice_s),
            },
            {
                order: 4,
                label: "Firma",
                sublabel: "Secretaria",
                path: "signature_s",
                content: <Outlet context={contextForOutlet} />,
                status: PERMIT_EXTENSION_STATUS.signature_s,
                uncompleteFields: getUncompleteFields(requiredFields.signature_s),
                isStepUntouched: isStepUntouched(requiredFields.signature_s),
            },
        ];

        steps = extensionSteps;
    }

    return {
        steps,
    };
};

export {usePermitExtensionSteps};
